"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeTypography = void 0;

var _constants = require("./constants");

var _lodash = _interopRequireDefault(require("lodash.clonedeep"));

var _lodash2 = _interopRequireDefault(require("lodash.merge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable no-console */
var themeTypography = function themeTypography() {
  var typographyOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var themedTypography = (0, _lodash["default"])(_constants.typographyDefaultValues);
  Object.keys(typographyOverrides).forEach(function (typographyName) {
    // Users can also pass in a supported Brand name (like "DoorDash" or "Caviar")
    // and this block will map it to the correct font family
    if (typographyName === 'FontFamily') {
      if (_constants.FontFamilyBrands[typographyOverrides.FontFamily]) {
        themedTypography.FontFamily = _constants.FontFamilyBrands[typographyOverrides.FontFamily];
      } else {
        themedTypography.FontFamily = typographyOverrides.FontFamily;
      }
    }

    if (typographyName === 'Density') {
      var validDensityVals = Object.values(_constants.TypographyDensities);

      if (validDensityVals.indexOf(typographyOverrides.Density) >= 0) {
        themedTypography.Density = typographyOverrides.Density;
      } else {
        console.error("User must provide one of the following supported values for the Typography.Density override: ".concat(validDensityVals, ",\n          ignoring invalid \"").concat(typographyOverrides.Density, "\" Density override"));
      }
    }

    if (typographyName === 'TextStyles') {
      themedTypography.TextStyles = (0, _lodash2["default"])(themedTypography.TextStyles, typographyOverrides.TextStyles);
    }
  });
  return themedTypography;
};

exports.themeTypography = themeTypography;